module.exports = __webpack_public_path__ + "static/get_started.56db788a.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/images/get_started.png
// module id = 657
// module chunks = 223907224879692